import React from 'react';
import { DownloadIcon } from 'lucide-react';
import { SAMPLE_URL } from '../data/content';
type SampleLinkProps = {
  /** 'block' ocupa todo el ancho (ofertas), 'inline' es compacto (tarjetas). */
  variant?: 'block' | 'inline';
  className?: string;
};
export function SampleLink({
  variant = 'block',
  className = ''
}: SampleLinkProps) {
  const base = 'inline-flex items-center justify-center gap-2 rounded-full border border-coral/40 bg-white font-sans font-bold uppercase tracking-[0.04em] text-coral transition-[transform,background-color,border-color] duration-150 ease-out hover:border-coral hover:bg-coral-soft/50 focus:outline-none focus-visible:ring-2 focus-visible:ring-coral focus-visible:ring-offset-2 active:scale-[0.98]';
  const size = variant === 'block' ? 'min-h-[52px] w-full px-6 text-[14px]' : 'min-h-[44px] px-5 text-[13px]';
  return <a href={SAMPLE_URL} target="_blank" rel="noopener noreferrer" className={`${base} ${size} ${className}`} data-id="element-133" data-mp="3t520ez30rmb5">
      <DownloadIcon aria-hidden="true" className="h-4 w-4" data-id="element-134" data-mp="2sx8nrc4ihu13" />
      Descargá muestra gratis
    </a>;
}